import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAllLanguages, ILanguage } from "../state/languagesSlice";

export const prettyLanguageName = (
  languageId: number,
  languages: ILanguage[],
  t: TFunction,
): string => {
  const lang = languages.find((l) => l.id === Number(languageId));
  if (lang?.IETF_BCP_47) {
    const key = `general.languages.IETF_BCP_47.${lang.IETF_BCP_47}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  if (lang?.name) return lang.name;
  return `#${languageId}`;
};

export const usePrettyLanguageName = () => {
  const { t } = useTranslation();
  const languages = useSelector(getAllLanguages);
  return (languageId: number): string => prettyLanguageName(languageId, languages, t);
};
